<template>
	<div>
		<div v-for="(item, i) in pages" :key="i" class="page flex-center">
			<img ref="img" :src="item">
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				pages: []
			}
		},

		async mounted() {
			let binaryString = atob(window.top._getPrintPDF());
			let length = binaryString.length;
			let uint8Array = new Uint8Array(length);
			for (let i = 0; i < length; i++) {
				uint8Array[i] = binaryString.charCodeAt(i);
			}
			let pdfDoc = await pdfjsLib.getDocument({data: uint8Array}).promise.catch(e => {
				window.top._beforePrintPDF('数据文件加载失败');
			});
			let pages = [];
			
			for (let i = 1; i <= pdfDoc.numPages; i++) {
				let page = await pdfDoc.getPage(i);
				let viewport = page.getViewport({
					scale: 2
				});

				let canvas = document.createElement('canvas');
				canvas.width = viewport.width;
				canvas.height = viewport.height;

				await page.render({
					canvasContext: canvas.getContext('2d'),
					viewport: viewport
				}).promise;

				pages.push(canvas.toDataURL());
			}

			this.pages = pages;
			this.$nextTick(() => {
				Promise.all(this.$refs.img.map(item => {
					return new Promise(resolve => {
						item.onload = resolve;
					})
				})).then(() => {
					window.top._beforePrintPDF();
					window.print();
				});
			});

			window.addEventListener('afterprint', function() { 
				window.top._afterPrintPDF();
			});
		}
	}
</script>

<style lang="stylus">
	@media print {
		.page {
			width: 100%;
			height: 100vh;
		}
	}
</style>